import type VisibilityStyles from './types';

const visibility: VisibilityStyles = {
  visible: {
    visibility: 'visible',
  },
  hidden: {
    visibility: 'hidden',
  },
};

export default visibility;
